import axios from 'axios'

// 登录
export function login(data) {
    return axios.post(process.env.VUE_APP_BASE_API + '/auth/login', data)
  }
  
  // 登出
  export function logout() {
    return axios.post(process.env.VUE_APP_BASE_API + '/auth/logout')
  }